module.exports = __webpack_public_path__ + "img/Surfing10_pdf.1d50fb99.png";